import { Menu, MenuButton, MenuItem, MenuItems } from "@headlessui/react";
import { ChevronDownIcon } from "@heroicons/react/20/solid";
import StudentSettings from "../components/StudentSettings";
import EditProfile from "../components/EditProfile";
import axios from "axios";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { MdArrowBack, MdArrowRight, MdDelete, MdHelp, MdKey, MdLanguage, MdLock, MdLogout, MdOutlinePersonPinCircle, MdPassword, MdPerson, MdPerson2, MdPolicy, MdSignLanguage } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import { DialogTitle, Button, Dialog, DialogActions, DialogContent, DialogContentText } from "@mui/material";
import StudentChangePassword from "../components/StudentChangePassword";
import { web_url } from "../../constant";
import StudentsTerms from "../components/StudentsTerms";
import StudentHelp from "../components/StudentHelp";
import { LucideKey, LucideLanguages } from "lucide-react";

const url = "http://localhost:8080/api/";
function StudentsSettingPageDesktop() {
    const changeLanguage = (lang) => {
        i18n.changeLanguage(lang);
    };
    const [language, setLanguage] = useState(() => {
        const categoryNow = localStorage.getItem('language') ? localStorage.getItem('language') : 'English';
        return categoryNow;
    })
    const { t, i18n } = useTranslation();

    useEffect(() => {
        switch (language) {
            case 'English':
                i18n.changeLanguage('en');
                break;
            case 'Sinhala':
                i18n.changeLanguage('si');
                break;
            case 'Tamil':
                i18n.changeLanguage('ta');
                break;
            default:
                i18n.changeLanguage('en');
                break;
        }
        localStorage.setItem('language', language);
    }, [language]);
    const navigate = useNavigate();

    const [personDetails, setPersonDetails] = useState({
        userName: "",
        school: "",
        district: "",
        grade: "",
        class: "",
        email: "",
        personalInterests: {}
    }
    )

    const [isLoading, setIsLoading] = useState(false);

    const [open, setOpen] = useState(false);

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const [open2, setOpen2] = useState(false);

    const handleClickOpen2 = () => {
        setOpen2(true);
    };

    const handleClose2 = () => {
        setOpen2(false);
    };
    const [openError, setOpenError] = useState(false);
    const [errorMsg, setErrorMsg] = useState('');

    const handleClickOpenError = (err) => {
        if (err.toLowerCase().includes('internal server error')) {
            setErrorMsg(t('t93'));
        } else {
            setErrorMsg(t('t94'));
        }
        setIsLoading(false);
        setOpenError(true);
    };

    const handleCloseError = () => {
        localStorage.clear();
        sessionStorage.clear();
        setOpenError(false);
        navigate('/loginas')
    };

    const [imageSrc, setImageSrc] = useState(null);

    useEffect(() => {
        if (isLoading) {
            setComponent(100);
        }
    }, [isLoading])

    useEffect(() => {
        setIsLoading(true);
        const getLogDetails = () => {
            return JSON.parse(localStorage.getItem("logDetails")) ||
                JSON.parse(sessionStorage.getItem("logDetails"));
        };

        const logDetails = getLogDetails();
        if (!logDetails?.email) {
            console.log("No user details found");
            setIsLoading(false);
            return;
        }


        const fetchStudentDetails = async () => {
            try {
                // Fetch student details
                const getLogDetails2 = () => {
                    return JSON.parse(localStorage.getItem("logDetails")) || JSON.parse(sessionStorage.getItem("logDetails"));
                };
                const logDetails2 = getLogDetails2();

                const configToken = {
                    headers: {
                        'Authorization': `Bearer ${logDetails2.token}`,
                    },
                };
                const apiUrl = `${web_url}/api/auth/students/${logDetails.email}`;
                const response = await axios.get(apiUrl, configToken);

                const [grade, section] = response.data.assignedClass.split("-");

                setPersonDetails({
                    userName: response.data.userFullName,
                    mobile: response.data.contactNumber,
                    school: response.data.school,
                    district: response.data.district,
                    grade,
                    class: section,
                    email: response.data.userEmail,
                    personal_interest: response.data.personalInterests || {},
                });

                localStorage.setItem('name', response.data.userFullName);
                localStorage.setItem('email', response.data.userEmail);
                localStorage.setItem('school', response.data.school);
                localStorage.setItem('teacherName', response.data.teacherName);
                localStorage.setItem('assignedClass', response.data.assignedClass);
                localStorage.setItem('penpalEmail', response.data.penpalEmail || "empty");
                localStorage.setItem('personalInterests', JSON.stringify(response.data.personalInterests));

                const profilePhotoUrl = `${web_url}/api/auth/students/${logDetails.email}/profile-photo`;
                const photoResponse = await axios.get(profilePhotoUrl, { ...configToken, responseType: "blob" });

                const reader = new FileReader();
                reader.readAsDataURL(photoResponse.data);
                reader.onloadend = () => {
                    const base64Image = reader.result; // Base64 encoded string

                    // Save to localStorage
                    localStorage.setItem("profilePhoto", base64Image);

                    // Set the image source
                    setImageSrc(base64Image);
                };
            } catch (error) {
                setErrorMsg("Error occured")
                console.error("Error occurred while fetching data", error);
            } finally {
                setIsLoading(false);
            }
        };

        fetchStudentDetails();

        return () => {
            if (imageSrc) {
                URL.revokeObjectURL(imageSrc);
            }
        };
    }, []);

    const handleDeleteAccount = () => {
        setIsLoading(true);
        const getLogDetails2 = () => {
            return JSON.parse(localStorage.getItem("logDetails")) || JSON.parse(sessionStorage.getItem("logDetails"));
        };
        const logDetails2 = getLogDetails2();

        const configToken = {
            headers: {
                'Authorization': `Bearer ${logDetails2.token}`,
            },
        };
        axios.patch(`${web_url}/api/auth/students/${personDetails.email}/delete-account?status=PENDING`, {}, configToken)
            .then((response) => {
                localStorage.removeItem('logDetails');
                sessionStorage.removeItem('logDetails');
                setIsLoading(false);
                navigate('/loginas')
            })
            .catch((err) => {
                if (err.response) {
                    // console.log(err.response)
                    if (err.response.data.error) {
                        handleClickOpenError(err.response.data.error);
                    } else if (err.response.data.message) {
                        handleClickOpenError(err.response.data.message);
                    } if (err.response.data.token) {
                        handleClickOpenError(err.response.data.token);
                    } else {
                        handleClickOpenError("An unknown error occured");
                    }

                }
                setIsLoading(false);
            })
    }

    const [component, setComponent] = useState(100)

    const [openLang, setOpenLang] = useState(false);
    const handleCloseLang = () => {
        setOpenLang(false);
    };

    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth <= 1270) {
                navigate('/mobile/student/settings')
            }
        };
        handleResize();
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);


    useEffect(() => {

        const getLogDetails = () => {
            return JSON.parse(localStorage.getItem("logDetails")) || JSON.parse(sessionStorage.getItem("logDetails"));
        };

        const checkAuth = () => {
            const logDetails = getLogDetails();
            const currentTime = new Date();

            if (!logDetails) {
                alert("Please re-sign up to continue");
                localStorage.clear();
                sessionStorage.clear();
                navigate('/loginas');
                return;
            } else if (logDetails.category.toLowerCase() !== "student") {
                alert("Please re-sign up to continue");
                // localStorage.clear();
                sessionStorage.clear();
                navigate('/loginas');
                return;
            }

            if (sessionStorage.getItem('exp')) {
                if (new Date(sessionStorage.getItem('exp')) < currentTime) {
                    alert("Please re-sign up to continue");
                    localStorage.clear();
                    sessionStorage.clear();
                    navigate('/loginas');
                } else if (sessionStorage.getItem('exp') !== logDetails.exp) {
                    alert("Please re-sign up to continue");
                    sessionStorage.clear();
                    navigate('/loginas');
                }
            } else {
                sessionStorage.setItem('exp', logDetails.exp);
                if (new Date(logDetails.exp) < currentTime) {
                    alert("Please re-sign up to continue");
                    localStorage.clear();
                    sessionStorage.clear();
                    navigate('/loginas');
                }
            }
        };

        checkAuth(); // Run on mount

        const handleStorageChange = (event) => {
            if (event.key === "logDetails") {
                checkAuth(); // Re-check authentication if storage changes
            }
        };

        window.addEventListener("storage", handleStorageChange);

        return () => {
            window.removeEventListener("storage", handleStorageChange);
        };
    }, []);

    const changeLanguageButtonClick = (lang) => {
        setOpenLang(true);
        const getLogDetails = () => {
            return JSON.parse(localStorage.getItem("logDetails")) || JSON.parse(sessionStorage.getItem("logDetails"));
        };
        const logDetails = getLogDetails();

        const languageChange = {
            preferredLanguage: lang
        }
        const config = {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${logDetails.token}`,
            },
        };
        axios.patch(`${web_url}/api/auth/students/${logDetails.email}`, languageChange, config).then((res) => {
            localStorage.setItem('preferredLang', lang);
            setLanguage(lang);
            if (lang === "English") {
                changeLanguage('en');
            }
            else if (lang === "Sinhala") {
                changeLanguage('si');
            } else if (lang === "Tamil") {
                changeLanguage('ta');
            }
            setOpenLang(false);
            setOpenMailLang(false);
        }).catch((err) => {
            alert('Error occured. Cannot change language now.')
            setOpenLang(false);
            setOpenMailLang(false);
        })
    }

    const [openMailLang, setOpenMailLang] = useState(false);

    const handleClickOpenMailLang = () => {
        setOpenMailLang(true);
    };

    const handleCloseMailLang = (lang) => {
        changeLanguageButtonClick(lang);
    };

    return (
        <div className={`font-urban bg-bgImg md:bg-bglarge bg-no-repeat bg-cover min-h-screen w-screen xl:pt-[50px]`}>
            <div className="xl:hidden absolute top-0 left-0 py-[25px] pl-[20px] md:pl-[30px] lg:pl-[40px]">
                <div className="flex justify-center items-center" >
                    <img className="h-[50px] md:h-[70px] lg:h-[90px]" src="/images/logo.svg" alt="logo" />
                    <p className="ml-[10px]  font-semibold text-[16px] md:text-[20px] lg:text-[25px]">{t('t1')}</p>
                </div>
            </div>
            <div className="rounded-md hidden xl:grid grid-cols-3 py-[5px] 2xl:py-[10px] bg-gradient-to-r from-[#FFA803] to-[#FFD12E] mx-[70px] px-[20px]">
                <div className="flex justify-start items-center">
                    <img className="h-[40px]" src="/images/logo.svg" alt="logo" />
                    <p className="ml-[10px] font-semibold text-[20px]">{t('t1')}</p>
                </div>
                <div className="grid grid-cols-3 w-full">
                    <div className="flex justify-center py-[10px] cursor-pointer relative group">
                        <img src="/images/top-icons/home-b.svg" onClick={() => navigate('/desktop/student/dashboard')} alt="home" />
                        <span className="absolute bottom-full mb-2 px-2 py-1 text-white text-sm bg-gray-800 rounded opacity-0 group-hover:opacity-100 transition-opacity">
                            {t('t410')}
                        </span>
                    </div>
                    <div className="flex justify-center py-[10px] cursor-pointer relative group">
                        <img src="/images/top-icons/mail-b.svg"
                            onClick={() => {
                                const mailRequest = {
                                    type: 'new',
                                    subject: 'nothing'
                                };
                                localStorage.setItem('threadId', JSON.stringify(mailRequest));
                                navigate('/desktop/student/mailbox')
                            }} />
                        <span className="absolute bottom-full mb-2 px-2 py-1 text-white text-sm bg-gray-800 rounded opacity-0 group-hover:opacity-100 transition-opacity">
                            {t('t411')}
                        </span>
                    </div>
                    <div className="flex justify-center py-[10px] cursor-pointer relative group">
                        <img src="/images/top-icons/settings-w.svg" onClick={() => navigate('/desktop/student/settings')} />
                        <span className="absolute bottom-full mb-2 px-2 py-1 text-white text-sm bg-gray-800 rounded opacity-0 group-hover:opacity-100 transition-opacity">
                            {t('t153')}
                        </span>
                    </div>
                </div>
                <div className="flex justify-end items-center">
                    <Menu as="div" className="text-left items-right">
                        <div>
                            <MenuButton className="inline-flex w-full justify-center gap-x-1.5 rounded-md bg-white px-3 py-2 lg:py-3 text-sm md:text-[17px] md:text-[21px] font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-black hover:bg-gray-50">
                                {language === "Sinhala" ? "සිංහල" : (language === "Tamil" ? "தமிழ்" : language)}
                                <ChevronDownIcon aria-hidden="true" className="-mr-1 size-5 md:size-6 text-gray-400" />
                            </MenuButton>
                        </div>

                        {
                            !isLoading &&
                            <MenuItems
                                transition
                                className="absolute right-0 z-10 mt-2 w-[200px] origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black/5 transition focus:outline-none data-[closed]:scale-95 data-[closed]:transform data-[closed]:opacity-0 data-[enter]:duration-100 data-[leave]:duration-75 data-[enter]:ease-out data-[leave]:ease-in"
                            >
                                <div className="py-1">
                                    <MenuItem>
                                        <button
                                            className="text-left w-full block px-4 py-2 text-sm md:text-md lg:text-lg text-gray-700 focus:bg-gray-100 focus:text-gray-900 focus:outline-none"
                                            onClick={() => {
                                                setLanguage("English");
                                                changeLanguage('en');
                                            }}
                                        >
                                            English
                                        </button>
                                    </MenuItem>
                                    <MenuItem>
                                        <button
                                            className="text-left w-full block px-4 py-2 text-sm md:text-md lg:text-lg text-gray-700 focus:bg-gray-100 focus:text-gray-900 focus:outline-none"
                                            onClick={() => {
                                                setLanguage("Sinhala");
                                                changeLanguage('si');
                                            }}
                                        >
                                            සිංහල
                                        </button>
                                    </MenuItem>
                                    <MenuItem>
                                        <button
                                            className="text-left w-full block px-4 py-2 text-sm md:text-md lg:text-lg text-gray-700 focus:bg-gray-100 focus:text-gray-900 focus:outline-none"
                                            onClick={() => {
                                                setLanguage("Tamil");
                                                changeLanguage('ta');
                                            }}
                                        >
                                            தமிழ்
                                        </button>
                                    </MenuItem>
                                </div>
                            </MenuItems>
                        }
                    </Menu>
                </div>
            </div>
            <div className="hidden xl:grid grid-cols-2 w-full">
                <div className="">
                    <div className="overflow-y-auto xl:hidden pl-[30px] pr-[30px] md:items-center pt-[80px] md:pt-[120px] lg:pt-[140px] xl:pt-[10px] 2xl:pt-[20px]">
                        <div className="flex items-center justify-start mt-[20px] lg:ml-[70px]">
                            <MdArrowBack size={25} className="md:hidden" onClick={() => {
                                navigate('/mobile/student/profile')
                            }} />
                            <MdArrowBack size={30} className="hidden md:block xl:hidden" onClick={() => {
                                navigate('/mobile/student/profile')
                            }} />
                            <p className="font-bold text-[20px] ml-[10px] md:text-[23px] lg:text-[25px] xl:text-[19px] 2xl:text-[25px]">{t('t153')}</p>
                        </div>
                    </div>

                    {
                        isLoading ?
                            <div className="items-center justify-center flex pt-[30px]">
                                <div className='w-10 h-10 border-2 border-t-transparent border-[#FFA803] rounded-full animate-spin'></div>
                            </div> :
                            <>
                                <div className="flex flex-col items-center pt-[20px] xl:pt-[40px] 2xl:pt-[60px]">
                                    {
                                        imageSrc ?
                                            <img className="xl:hidden  bg-black h-[150px] w-[150px] md:h-[130px] md:w-[130px] lg:h-[150px] lg:w-[150px] xl:h-[100px] xl:w-[100px] rounded-full object-contain" src={imageSrc} alt="profile" />
                                            :
                                            <img className="xl:hidden h-[150px] md:h-[130px] lg:h-[150px] xl:h-[100px] rounded-full" src="/images/img.jpg" alt="profile" />

                                    }
                                    <div className="flex flex-col pt-[20px] justify-center items-center pt-[5px]">
                                        <p className="xl:hidden font-bold text-[25px] md:text-[40px] lg:text-[50px] xl:text-[30px] text-black">{personDetails.userName}</p>
                                        <p className="hidden xl:block font-bold text-[25px] md:text-[40px] lg:text-[50px] xl:text-[30px] text-black">Settings</p>
                                        <p className="xl:hidden font-normal text-[19px] md:text-[27px] md:text-[35px] xl:text-[20px] text-black">{personDetails.mobile}</p>
                                    </div>
                                </div>
                                <hr className=" border-gray-400 flex items-center mx-[30px] mt-[20px] xl:ml-[90px]" />
                                <div className="pt-[30px] xl:pl-[40px]">
                                    <div className=" flex w-full items-center justify-between mt-[10px] pl-[30px] md:pl-[110px] lg:pl-[140px] xl:pl-[50px] pr-[30px] md:pr-[110px] lg:pr-[140px] xl:pr-[0px]">
                                        <div className={`hover:bg-[#FCE7AE] hover:bg-opacity-50 cursor-pointer flex w-full items-center justify-between ${component === 0 ? 'bg-[#FCE7AE]' : ''} px-[10px] py-[5px] rounded-md`} onClick={() => setComponent(0)}>
                                            <div className="flex items-center gap-[7px] ">
                                                <MdPerson />
                                                <p className="text-black text-[17px] md:text-[25px] lg:text-[30px] xl:text-[16px] 2xl:text-[20px]">
                                                    {t('t154')}
                                                </p>
                                            </div>
                                            <MdArrowRight size={30} className="hidden xl:block mr-[30px] md:mr-[110px] lg:mr-[140px] xl:mr-[50px] cursor-pointer" />
                                        </div>
                                    </div>

                                    <div className="flex w-full items-center justify-between ">
                                        <div className="flex w-full items-center justify-between mt-[10px] pl-[30px] md:pl-[110px] lg:pl-[140px] xl:pl-[50px] pr-[30px] md:pr-[110px] lg:pr-[140px] xl:pr-[0px]">
                                            <div className={`hover:bg-[#FCE7AE] hover:bg-opacity-50 cursor-pointer flex w-full items-center justify-between px-[10px] py-[5px] rounded-md ${component === 1 ? 'bg-[#FCE7AE]' : ''}`} onClick={() => setComponent(1)}>
                                                <div className="flex items-center gap-[7px]">
                                                    <LucideKey size={16} />
                                                    <p className="text-black text-[17px] md:text-[25px] lg:text-[30px] xl:text-[16px] 2xl:text-[20px]">
                                                        {t('t155')}
                                                    </p>
                                                </div>
                                                <MdArrowRight size={30} className="hidden xl:block mr-[30px] md:mr-[110px] lg:mr-[140px] xl:mr-[50px] cursor-pointer" />

                                            </div>
                                        </div>
                                    </div>

                                    <div className="flex w-full items-center justify-between ">
                                        <div className="flex w-full items-center justify-between mt-[10px] pl-[30px] md:pl-[110px] lg:pl-[140px] xl:pl-[50px] pr-[30px] md:pr-[110px] lg:pr-[140px] xl:pr-[0px]">
                                            <div className={`hover:bg-[#FCE7AE] hover:bg-opacity-50 cursor-pointer flex w-full items-center justify-between px-[10px] py-[5px] rounded-md ${component === 2 ? 'bg-[#FCE7AE]' : ''}`} onClick={() => setComponent(2)}>
                                                <div className="flex items-center gap-[7px]">
                                                    <MdHelp size={16} />
                                                    <p className="text-black text-[17px] md:text-[25px] lg:text-[30px] xl:text-[16px] 2xl:text-[20px]">
                                                        {t('t156')}
                                                    </p>
                                                </div>
                                                <MdArrowRight size={30} className="hidden xl:block mr-[30px] md:mr-[110px] lg:mr-[140px] xl:mr-[50px] cursor-pointer" />

                                            </div>
                                        </div>
                                    </div>

                                    <div className="flex w-full items-center justify-between ">
                                        <div className="flex w-full items-center justify-between mt-[10px] pl-[30px] md:pl-[110px] lg:pl-[140px] xl:pl-[50px] pr-[30px] md:pr-[110px] lg:pr-[140px] xl:pr-[0px]">
                                            <div className={`hover:bg-[#FCE7AE] hover:bg-opacity-50 cursor-pointer flex w-full items-center justify-between px-[10px] py-[5px] rounded-md ${component === 3 ? 'bg-[#FCE7AE]' : ''}`} onClick={() => setComponent(3)}>
                                                <div className="flex items-center gap-[7px]">
                                                    <MdLock size={16} />
                                                    <p className="text-black text-[17px] md:text-[25px] lg:text-[30px] xl:text-[16px] 2xl:text-[20px]">
                                                        {t('t157')}
                                                    </p>
                                                </div>
                                                <MdArrowRight size={30} className="hidden xl:block mr-[30px] md:mr-[110px] lg:mr-[140px] xl:mr-[50px] cursor-pointer" />

                                            </div>
                                        </div>
                                    </div>

                                    <div className="flex w-full items-center justify-between ">
                                        <div className="flex w-full items-center justify-between mt-[10px] pl-[30px] md:pl-[110px] lg:pl-[140px] xl:pl-[50px] pr-[30px] md:pr-[110px] lg:pr-[140px] xl:pr-[0px]">
                                            <div className={`hover:bg-[#FCE7AE] hover:bg-opacity-50 cursor-pointer flex w-full items-center justify-between px-[10px] py-[5px] rounded-md`} onClick={() => handleClickOpenMailLang(true)}>
                                                <div className="flex items-center gap-[7px]">
                                                    <LucideLanguages size={16} />
                                                    <p className="text-black text-[17px] md:text-[25px] lg:text-[30px] xl:text-[16px] 2xl:text-[20px]">
                                                        {t('t428')}
                                                    </p>
                                                </div>
                                                <MdArrowRight size={30} className="hidden xl:block mr-[30px] md:mr-[110px] lg:mr-[140px] xl:mr-[50px] cursor-pointer" />

                                            </div>
                                        </div>
                                    </div>


                                   
                                    <div onClick={() => handleClickOpen()} className="cursor-pointer flex w-full items-center mt-[15px]">

                                        <div className="hover:underline hover:decoration-red-500 flex items-center gap-[7px] pl-[30px] md:pl-[110px] lg:pl-[140px] xl:pl-[58px] pr-[30px] md:pr-[110px] lg:pr-[140px] xl:pr-[0px]">
                                            <MdDelete className={"text-[#ff2d00]"} />
                                            <p className=" text-[#ff2d00] text-[17px] md:text-[25px] lg:text-[30px] xl:text-[16px] 2xl:text-[20px]">
                                                {t('t158')}
                                            </p>
                                        </div>

                                    </div>

                                    <div onClick={() => handleClickOpen2()} className="cursor-pointer flex w-full items-center mt-[15px]">
                                        <div className="hover:underline hover:decoration-red-500 flex items-center gap-[7px] pl-[30px] md:pl-[110px] lg:pl-[140px] xl:pl-[60px] pr-[30px] md:pr-[110px] lg:pr-[140px] xl:pr-[0px]">
                                            <MdLogout className="text-[#ff2d00]" />
                                            <p className="text-[#ff2d00] text-[17px] md:text-[25px] lg:text-[30px] xl:text-[16px] 2xl:text-[20px]">
                                                {t('t159')}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </>
                    }

                </div>
                {
                    component === 0 &&
                    <div className=" ">
                        <EditProfile t={t} />
                    </div>
                }
                {
                    component === 1 &&
                    <div className=" ">
                        <StudentChangePassword t={t} />
                    </div>
                }

                {
                    component === 3 &&
                    <div className=" ">
                        <StudentsTerms t={t} />
                    </div>
                }

                {
                    component === 2 &&
                    <div className=" ">
                        <StudentHelp t={t} />
                    </div>
                }
            </div>
            <Dialog
                open={openError}
                onClose={(event, reason) => {
                    if (reason !== "backdropClick") {
                        handleCloseError(); // Allow closing only for other reasons
                    }
                }}
                aria-labelledby="custom-dialog-title"
                aria-describedby="custom-dialog-description"
                className="backdrop-blur-sm"
            >
                <DialogTitle
                    id="custom-dialog-title"
                    className="text-2xl font-bold text-gray-800 border-b border-gray-300 pb-2"
                >
                    {t('t95')}
                </DialogTitle>
                <DialogContent className="bg-gray-50">
                    <DialogContentText
                        id="custom-dialog-description"
                        className="text-gray-600 text-md mt-2"
                    >
                        {errorMsg}
                    </DialogContentText>
                </DialogContent>
                <DialogActions className="px-4 py-2">
                    <Button
                        onClick={handleCloseError}
                        className="bg-[#F2AC0E] text-white px-4 py-2 rounded-md"
                        style={{ backgroundColor: '#F2AC0E', color: 'white', fontWeight: 'bold' }}
                    >
                        {t('t96')}
                    </Button>
                </DialogActions>
            </Dialog>

            <Dialog
                open={open}
                onClose={(event, reason) => {
                    if (reason !== "backdropClick") {
                        handleClose(); // Allow closing only for other reasons
                    }
                }}
                aria-labelledby="custom-dialog-title"
                aria-describedby="custom-dialog-description"
                className="backdrop-blur-sm md:mr-[0px]"
            >
                <DialogContent className="bg-[#FFF6DA]">

                    <DialogContent
                        id="custom-dialog-description"
                        className="text-gray-600 text-md mt-2"
                    >
                        <div className='flex flex-col justify-center items-center text-center'>
                            <div className='mt-[0px]'>{t('t160_1')}</div>
                            <div className="flex justify-center item-center gap-[20px] mt-[20px]">
                                <Button
                                    onClick={handleClose}
                                    className="bg-[#F2AC0E] text-white px-4 py-2 rounded-md mt-[10px]"
                                    style={{ backgroundColor: '#F2AC0E', color: 'white', fontWeight: 'bold' }}
                                >
                                    {t('t145')}
                                </Button>
                                <Button
                                    onClick={() => { handleDeleteAccount() }}
                                    className="bg-[#F2AC0E] text-white px-4 py-2 rounded-md mt-[10px]"
                                    style={{ backgroundColor: '#F2AC0E', color: 'white', fontWeight: 'bold' }}
                                >
                                    {t('t144')}
                                </Button>
                            </div>
                        </div>
                    </DialogContent>
                </DialogContent>
            </Dialog>

            <Dialog
                open={open2}
                onClose={(event, reason) => {
                    if (reason !== "backdropClick") {
                        handleClose2(); // Allow closing only for other reasons
                    }
                }}
                aria-labelledby="custom-dialog-title"
                aria-describedby="custom-dialog-description"
                className="backdrop-blur-sm md:mr-[0px]"
            >
                <DialogContent className="bg-[#FFF6DA]">

                    <DialogContent
                        id="custom-dialog-description"
                        className="text-gray-600 text-md mt-2"
                    >
                        <div className='flex flex-col justify-center items-center text-center'>
                            <div className='mt-[0px]'>{t('t161')}</div>
                            <div className="flex justify-center item-center gap-[20px] mt-[20px]">
                                <Button
                                    onClick={handleClose2}
                                    className="bg-[#F2AC0E] text-white px-4 py-2 rounded-md mt-[10px]"
                                    style={{ backgroundColor: '#F2AC0E', color: 'white', fontWeight: 'bold' }}
                                >
                                    {t('t145')}
                                </Button>
                                <Button
                                    onClick={() => {
                                        localStorage.clear();
                                        sessionStorage.clear();
                                        navigate('/loginas')
                                    }}
                                    className="bg-[#F2AC0E] text-white px-4 py-2 rounded-md mt-[10px]"
                                    style={{ backgroundColor: '#F2AC0E', color: 'white', fontWeight: 'bold' }}
                                >
                                    {t('t144')}
                                </Button>
                            </div>
                        </div>
                    </DialogContent>
                </DialogContent>
            </Dialog>

            <Dialog
                open={openLang}
                onClose={(event, reason) => {
                    if (reason !== "backdropClick") {
                        handleCloseLang(); // Allow closing only for other reasons
                    }
                }}
                aria-labelledby="custom-dialog-title"
                aria-describedby="custom-dialog-description"
                className="backdrop-blur-sm"
            >
                <DialogContent className="bg-[#FFF6DA]">

                    <DialogContent
                        id="custom-dialog-description"
                        className="text-gray-600 text-md mt-2"
                    >
                        <div className="items-center justify-center flex">
                            <div className='w-10 h-10 border-2 border-t-transparent border-[#FFA803] rounded-full animate-spin'></div>
                        </div>
                    </DialogContent>

                </DialogContent>
            </Dialog>

            <Dialog
                open={openMailLang}
                onClose={(event, reason) => {
                    if (reason !== "backdropClick") {
                        setOpenMailLang(false);
                    }
                }}
                aria-labelledby="custom-dialog-title"
                aria-describedby="custom-dialog-description"
                className="backdrop-blur-sm"
            >
                <DialogTitle
                    id="custom-dialog-title"
                    className="bg-[#FFF6DA] text-2xl font-bold text-gray-800 border-b border-gray-300 pb-2"
                >
                    {t('t428')}
                </DialogTitle>
                <DialogContent
                    className="bg-[#FFF6DA] text-gray-600 text-md"
                >
                    <div className="flex items-center justify-center gap-[10px] mt-[10px]">
                        <button className={` ${localStorage.getItem('preferredLang') && localStorage.getItem('preferredLang') === "English" ? "bg-white border border-[#F2AC0E] text-[#F2AC0E]" : "bg-[#F2AC0E] text-white"} min-w-[100px] px-4 py-2 rounded-md font-bold`}
                            onClick={() => { handleCloseMailLang("English") }}
                        >
                            English
                        </button>
                        <button className={` ${localStorage.getItem('preferredLang') && localStorage.getItem('preferredLang') === "Sinhala" ? "bg-white border border-[#F2AC0E] text-[#F2AC0E]" : "bg-[#F2AC0E] text-white"} min-w-[100px] px-4 py-2 rounded-md font-bold`}
                            onClick={() => { handleCloseMailLang("Sinhala") }}
                        >
                            සිංහල
                        </button>
                        <button className={` ${localStorage.getItem('preferredLang') && localStorage.getItem('preferredLang') === "Tamil" ? "bg-white border border-[#F2AC0E] text-[#F2AC0E]" : "bg-[#F2AC0E] text-white"} min-w-[100px]  px-4 py-2 rounded-md font-bold`}
                            onClick={() => { handleCloseMailLang("Tamil") }}
                        >
                            தமிழ்
                        </button>
                    </div>
                </DialogContent>
            </Dialog>
        </div>
    )
}

export default StudentsSettingPageDesktop;
